import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pin-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pin-icon.component.html',
  styleUrls: ['./pin-icon.component.css'],
})
export class PinIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
